function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7806 14.4693L32.7806 11.4693C32.6397 11.3283 32.4491 11.2503 32.2497 11.2503H31.4997V10.5003C31.4997 10.3008 31.4202 10.1102 31.2807 9.96926L25.2808 3.96936C24.0778 2.76646 22.0618 0.750488 17.9999 0.750488C13.9409 0.750488 12.0794 2.61199 10.7189 3.96943C10.5044 4.18395 10.4399 4.5064 10.5569 4.78694C10.6725 5.06741 10.947 5.25044 11.2499 5.25044C17.2993 5.25044 17.9999 7.81843 17.9999 9.75038C17.9999 11.3554 17.0909 12.5778 16.5104 13.2004L21.4108 18.1008C22.7368 17.2038 24.6208 16.1448 25.4998 16.2229V17.2503C25.4998 17.4498 25.5793 17.6403 25.7188 17.7813L29.4688 21.5312C29.6097 21.6707 29.8003 21.7503 29.9997 21.7503H30.0253C30.2337 21.7443 30.4288 21.6513 30.5638 21.4952L35.8138 15.4953C36.0747 15.1968 36.0596 14.7498 35.7806 14.4693Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13399 28.5558C0.403519 29.2863 0 30.2583 0 31.3802C0 33.5147 1.7355 35.2502 3.86996 35.2502C4.95747 35.2502 6.00145 34.7882 6.7334 33.9842L20.2753 19.0879L15.4393 14.2505L1.13399 28.5558Z",
  fill: "white"
});

function SvgHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.c70402f1.svg";
export { ForwardRef as ReactComponent };